import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPhoto = loadable(() => import(/* webpackChunkName: "content/guestSitePhoto" */ '.'), 'Photo');
